import { AbstractModel } from "../base"
import type { IArticle, IArticleData } from "./article.types"
import { Tag } from "../tag/tag"
import type { ITag } from "../tag/tag.types"

export class Article extends AbstractModel implements IArticle {
  readonly id?: number
  readonly title: string
  readonly link: string
  readonly created?: Date
  readonly modified?: Date
  readonly tags: ITag[] = []

  constructor(data: IArticleData) {
    super()

    // Validate data
    const requiredFields: (keyof IArticleData)[] = ['title', 'link']
    this.validate(data, requiredFields)

    // Initialize object assuming data valid
    this.title = data.title!
    this.link = data.link!

    if (data.id) {
      this.id = data.id
    }

    if (data.tags) {
      this.tags = data.tags.map((tag) => new Tag(tag))
    }

    if (data.created) {
      this.created =
        typeof data.created === 'string' ? new Date(data.created) : data.created    
    }

    if (data.modified) {
      this.modified =
        typeof data.modified === 'string' ? new Date(data.modified) : data.modified
    }
  }
}